import { render } from "./SuperAdminInstructions.vue?vue&type=template&id=5a86956c"
import script from "./SuperAdminInstructions.vue?vue&type=script&lang=js"
export * from "./SuperAdminInstructions.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/survey-cms/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__